import { z } from "zod";

export const rawStringSchema = z.object({ raw: z.string() });
